<template>
  <div class="main-page">
    <template v-if="showHeader">
      <section class="page-section mb-3">
        <div class="container-fluid">
          <div class="grid card pt-2 pb-3 justify-content-between">
            <div class="col">
              <div class="">
                <div class="text-3xl font-bold mt-2">Roles & Permissions</div>
              </div>
            </div>
            <div class="col-12 md:col-3 lg:col-2">
              <div class="">
                <template v-if="$auth.canView('/user_roles/add')">
                  <Button
                    label="Add New Role"
                    icon="pi pi-plus"
                    @click="
                      app.openPageDialog({
                        page: 'user_roles/add',
                        url: `/user_roles/add`,
                        closeBtn: true,
                        persistent: true,
                        position: 'bottom',
                        width: '30%',
                      })
                    "
                    class="w-full p-button-rounded bg-primary"
                  />
                </template>
              </div>
            </div>
            <!-- <div class="col-12 md:col-5 lg:col-4">
              <div class="">
                <span class="p-input-icon-left w-full">
                  <i class="pi pi-search" />
                  <InputText
                    outlined
                    dense
                    placeholder="Search"
                    class="w-full"
                    :value="searchText"
                    @input="
                      debounce(() => {
                        searchText = $event.target.value;
                      })
                    "
                  />
                </span>
              </div>
            </div> -->
          </div>
        </div>
      </section>
    </template>
    <section class="page-section">
      <div class="container-fluid">
        <div class="grid">
          <div class="col comp-grid">
            <div class="">
              <div class="flex align-items-center justify-content-around">
                <div v-if="searchText" :class="filterTagClass">
                  <Breadcrumb
                    :home="{
                      icon: 'pi pi-times text-lg mr-3',
                      label: 'Search',
                    }"
                    :model="[
                      {
                        label: `${searchText}`,
                      },
                    ]"
                  >
                    <template #item="{ item }">
                      <div
                        class="cursor-pointer"
                        :class="item.icon"
                        @click="
                          () => {
                            clearSearch();
                          }
                        "
                      ></div>
                      <a :href="item.url">{{ item.label }}</a>
                    </template>
                  </Breadcrumb>
                </div>
              </div>
              <div class="">
                <div>
                  <template v-if="showBreadcrumbs && $route.query.tag">
                    <Breadcrumb
                      :home="{ icon: 'pi pi-home', to: '/user_roles' }"
                      :model="pageBreadCrumb"
                    />
                  </template>
                  <div class="grid justify-content-start">
                    <!-- Master Page Start -->
                    <div class="col-12">
                      <div class="" :class="{ card: !isSubPage }">
                        <!-- page records template -->
                        <div class="page-records" v-if="!loading">
                          <DataTable
                            :lazy="true"
                            :loading="loading"
                            :value="records"
                            dataKey="role_id"
                            @sort="onSort($event)"
                            class=""
                            :showGridlines="false"
                            :rowHover="true"
                            responsiveLayout="stack"
                          >
                            <Column
                              field="role_name"
                              header="Role Name"
                              :sortable="true"
                            >
                              <template #body="{ data }">
                                {{ data.role_name }}
                              </template>
                            </Column>
                            <Column headerStyle="" headerClass="text-center">
                              <template #body="{ data }">
                                <Menubar
                                  class="p-0"
                                  ref="actionMenu"
                                  :model="getActionMenuModel(data)"
                                />
                              </template>
                            </Column>
                          </DataTable>
                        </div>
                        <!-- page loading indicator -->
                        <template v-if="loading">
                          <div>
                            <DataTable
                              :value="[1, 2, 3, 4, 5]"
                              responsiveLayout="scroll"
                            >
                              <Column>
                                <template #body>
                                  <Skeleton height="3em" />
                                </template>
                              </Column>
                            </DataTable>
                          </div>
                        </template>
                        <!-- end of page loading indicator-->
                        <!-- Empty record -->
                        <template v-if="pageReady && !records.length">
                          <div
                            class="p-3 my-3 text-500 text-lg font-medium text-center"
                          >
                            No roles found
                          </div>
                        </template>
                        <!-- end of empty record-->
                        <!-- pagination component-->
                        <template v-if="showFooter">
                          <div class="">
                            <div v-show="pageReady">
                              <div class="flex justify-content-between">
                                <div
                                  class="flex justify-content-center flex-grow-0"
                                >
                                  <template
                                    v-if="$auth.canView('user_roles/delete')"
                                  >
                                    <div
                                      v-if="selectedItems.length"
                                      class="m-2"
                                    >
                                      <Button
                                        @click="deleteItem(selectedItems)"
                                        icon="pi pi-trash"
                                        class="p-button-danger"
                                        title="Delete Selected"
                                      />
                                    </div>
                                  </template>
                                </div>
                                <div
                                  v-if="paginate && totalPages > 1"
                                  class="flex-grow-1"
                                >
                                  <Paginator
                                    class="border-none bg-transparent py-3"
                                    :first="recordsPosition"
                                    @page="
                                      (event) => {
                                        pagination.page = event.page + 1;
                                      }
                                    "
                                    :rows="pagination.limit"
                                    :totalRecords="totalRecords"
                                  >
                                    <template #start>
                                      <span class="text-sm text-gray-500 px-2">
                                        Records
                                        <b
                                          >{{ recordsPosition }} of
                                          {{ totalRecords }}</b
                                        >
                                      </span>
                                    </template>
                                    <template #end> </template>
                                  </Paginator>
                                </div>
                              </div>
                            </div>
                          </div>
                        </template>
                        <!-- end of pagination component-->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script setup>
import { reactive, toRefs, onMounted } from "vue";
import { useApp } from "@/composables/app.js";
import { useAuth } from "@/composables/auth";
import { useListPage } from "@/composables/listpage.js";
//[--PAGE-IMPORT-STATEMENT--]
const props = defineProps({
  primaryKey: {
    type: String,
    default: "role_id",
  },
  pageName: {
    type: String,
    default: "user_roles",
  },
  routeName: {
    type: String,
    default: "user_roleslist",
  },
  apiPath: {
    type: String,
    default: "user_roles/index",
  },
  paginate: {
    type: Boolean,
    default: true,
  },
  showHeader: {
    type: Boolean,
    default: true,
  },
  showFooter: {
    type: Boolean,
    default: true,
  },
  showBreadcrumbs: {
    type: Boolean,
    default: true,
  },
  exportButton: {
    type: Boolean,
    default: true,
  },
  importButton: {
    type: Boolean,
    default: false,
  },
  multiCheckbox: {
    type: Boolean,
    default: false,
  },
  emptyRecordMsg: {
    type: String,
    default: "No roles found",
  },
  titleBeforeDelete: {
    type: String,
    default: "Delete record",
  },
  msgBeforeDelete: {
    type: String,
    default: "Are you sure you want to delete this record?",
  },
  msgAfterDelete: {
    type: String,
    default: "Record deleted successfully",
  },
  page: {
    type: Number,
    default: 1,
  },
  limit: {
    type: Number,
    default: 10,
  },
  mergeRecords: {
    // for infinite loading
    type: Boolean,
    default: false,
  },
  search: {
    type: String,
    default: "",
  },
  fieldName: null,
  fieldValue: null,
  sortBy: {
    type: String,
    default: "",
  },
  sortType: {
    type: String,
    default: "", //desc or asc
  },
  isSubPage: {
    type: Boolean,
    default: false,
  },
  filterTagClass: {
    type: String,
    default:
      "surface-card p-2 text-500 flex-grow-1 text-center m-1 mb-3 flex-grow-1 text-center",
  },
});
const app = useApp();
const auth = useAuth();
const filters = reactive({});
//init list page hook
const page = useListPage(props, filters);
//page state
const {
  totalRecords, // total records from api - Number
  recordCount, // current record count - Number
  loading, // Api loading state - Boolean
  selectedItems, // Data table selected items -Array
  pagination, //Pagination object - Object
  searchText, // search text - String
  pageReady, // api data loaded successfully
} = toRefs(page.state);
//page computed propties
const {
  records, // page record from store - Array
  apiUrl, // current api path - URL
  currentRecord, // master detail selected record - Object
  pageBreadCrumb, // get page navigation paths - Object
  canLoadMore, // if api has more data for loading - Boolean
  finishedLoading, // if api has finished loading - Boolean
  totalPages, // total number of pages from api - Number
  recordsPosition, // current record position from api - Number
} = page.computedProps;
//page methods
const {
  load, // load data from api
  reload, // reset pagination and load data
  loadNextPage, // load next page
  loadPreviousPage, // load previous page
  exportPage, // export page records - args = (exportFormats, apiUrl, pageName)
  clearSearch, // clear input search
  debounce, // debounce input search
  onSort, // reset page number before sort from api
  deleteItem, // delete item by id or selected items - args = (id) or (selectedItems)
  setCurrentRecord, // master detail set current record
  isCurrentRecord, // master detail
  removeFilter, // remove page filter item - args = (filter.propertyname)
  getFilterLabel, // get filter item display label - args = (filter.propertyname)
  filterHasValue, //check if filter item has value - args = (filter.propertyname)
  importComplete, // reload page after data import
} = page.methods;
function getActionMenuModel(data) {
  return [
    {
      label: "Add/View Permissions",
      to: `/user_roles/view/${data.role_id}`,
      icon: "pi pi-eye",
      visible: auth.canView("user_roles/view"),
    },
    {
      label: "Edit Role",
      command: (event) => {
        app.openPageDialog({
          page: "user_roles/edit",
          url: `/user_roles/edit/${data.role_id}`,
          closeBtn: true,
          persistent: true,
          position: "bottom",
          width: "30%",
        });
      },
      icon: "pi pi-pencil",
      visible: auth.canView("user_roles/edit"),
    },
    {
      label: "Delete",
      command: (event) => {
        deleteItem(data.role_id);
      },
      icon: "pi pi-minus-circle",
      visible: auth.canView("user_roles/delete"),
    },
  ];
}
onMounted(() => {
  const pageTitle = "Roles & Permissions";
  app.setPageTitle(props.routeName, pageTitle);
  load();
});
</script>
<style scoped></style>
<style scoped></style>
